import { InitPageStrict } from "../index";

declare class ResizeObserver {
  constructor(callback: () => void);
  observe(target: Element): void;
}

class ItemDetailsMapV2 {
  private readonly box = document.getElementById("sn_map_v2") as HTMLElement;
  private readonly img = document.getElementById("sn_map_v2_img") as HTMLImageElement;

  constructor() {
    if (!this.box || !this.img || this.box.dataset.pxX === "") return;
    this.img.addEventListener("load", () => this.place());
    new ResizeObserver(() => this.place()).observe(this.img);
    if (this.img.complete) this.place();
  }

  private place(): void {
    if (!this.img.naturalWidth || !this.img.clientWidth) return;
    const k = this.img.clientWidth / this.img.naturalWidth;
    const x = parseFloat(this.box.dataset.pxX) * k;
    const y = parseFloat(this.box.dataset.pxY) * k;

    this.attrs("sn_map_v2_halo", { cx: x, cy: y, r: 16 });
    this.attrs("sn_map_v2_core", { cx: x, cy: y, r: 3 });
    document.getElementById("sn_map_v2_dot").style.display = "";
    this.placeTip(x, y);
  }

  private placeTip(x: number, y: number): void {
    const tip1 = document.getElementById("sn_map_v2_tip1") as unknown as SVGTextElement;
    const tip2 = document.getElementById("sn_map_v2_tip2") as unknown as SVGTextElement;
    tip1.textContent = this.box.dataset.tipPosition;
    tip2.textContent = this.box.dataset.tipDetail;

    const width = Math.max(tip1.getComputedTextLength(), tip2.getComputedTextLength()) + 24;
    const height = 44;
    const tx = x + 26 + width > this.img.clientWidth ? x - 26 - width : x + 26;
    const ty = Math.max(4, y - 56);

    this.attrs("sn_map_v2_tip", { x: tx, y: ty, width: width, height: height });
    this.attrs("sn_map_v2_tip1", { x: tx + 12, y: ty + 19 });
    this.attrs("sn_map_v2_tip2", { x: tx + 12, y: ty + 36 });
  }

  private attrs(id: string, values: Record<string, number>): void {
    const el = document.getElementById(id);
    Object.keys(values).forEach((name) => el.setAttribute(name, String(values[name])));
  }
}

export function LoadPage() {
  InitPageStrict("items item_details", () => {
    new ItemDetailsMapV2();
  });
}
